import { useContext } from 'react';
import { useAppSelector } from '@web-common/state/createStore';
import { WriteContext } from '@web-setting/Mail/components/CustomTemplate/template_add_modal';
function useRightSideColumnStatusSelector() {
    const { isMailTemplate } = useContext(WriteContext);
    const showStatus = useAppSelector(state => {
        var _a, _b, _c, _d;
        return isMailTemplate
            ? [(_a = state.mailTemplateReducer.mailTemplateContent.status) === null || _a === void 0 ? void 0 : _a.showContact, false, false]
            : [
                (_b = state.mailReducer.currentMail.status) === null || _b === void 0 ? void 0 : _b.showContact,
                (_c = state.mailReducer.currentMail.status) === null || _c === void 0 ? void 0 : _c.userBusyFreeShow,
                (_d = state.mailReducer.currentMail.status) === null || _d === void 0 ? void 0 : _d.sensitiveTipShow,
            ];
    });
    return showStatus;
}
export default useRightSideColumnStatusSelector;
